import { SectionHeader } from '../rows/SectionHeader'
import { getStatusColor, CompletionBadge } from '@/components/ui/metrics'
import type { MonthMetrics } from '@/features/history/types'

interface MarketingSectionProps {
  metrics: MonthMetrics
  weeklyAvg: (v: number) => number
  formatCurrency: (v: number) => string
}

export function MarketingSection({ metrics, weeklyAvg, formatCurrency }: MarketingSectionProps) {
  const { marketing_budget: budget, cost_per_lead: cpl } = metrics
  return (
    <>
      <SectionHeader label="Маркетинг" color="indigo" />
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm">Бюджет маркетинга</td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(weeklyAvg(budget.plan))}</td>
        <td className={`p-3 text-right font-mono text-sm ${getStatusColor(budget.completion, budget.plan)}`}>
          {formatCurrency(weeklyAvg(budget.fact))}
        </td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(budget.plan)}</td>
        <td className={`p-3 text-right font-mono text-sm font-semibold ${getStatusColor(budget.completion, budget.plan)}`}>
          {formatCurrency(budget.fact)}
        </td>
        <td className={`p-3 text-center ${getStatusColor(budget.completion, budget.plan)}`}>
          <CompletionBadge metric={budget} />
        </td>
      </tr>
      <tr className="border-b border-border hover:bg-muted/30 transition-colors">
        <td className="p-3 pl-6 text-sm">Стоимость лида</td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(cpl.plan)}</td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(cpl.fact)}</td>
        <td className="p-3 text-right font-mono text-sm">{formatCurrency(cpl.plan)}</td>
        <td className="p-3 text-right font-mono text-sm font-semibold">{formatCurrency(cpl.fact)}</td>
        <td className="p-3 text-center text-muted-foreground">-</td>
      </tr>
    </>
  )
}
